import { ClientError } from '@tribeplatform/gql-client/lib'
import {
  PaginatedMember,
  QuerySearchMembersArgs,
} from '@tribeplatform/gql-client/types'
import { PaginatedMemberFields } from '@tribeplatform/gql-client/types/generated'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { getInfiniteSearchMembersKey } from '@tribeplatform/react-sdk/utils/keys'

type Props = {
  variables: QuerySearchMembersArgs
  fields?: PaginatedMemberFields
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedMember>
}

export const useInfiniteSearchMembers = ({
  variables,
  fields,
  useInfiniteQueryOptions,
}: Props) => {
  const { client } = useTribeClient()

  return useInfiniteQuery<PaginatedMember, ClientError>(
    getInfiniteSearchMembersKey({ variables, fields }),
    ({ pageParam: after }) =>
      client.searchMembers({ after, ...variables }, fields),
    {
      refetchOnWindowFocus: false,
      ...useInfiniteQueryOptions,
    },
  )
}
